import ky from "ky";
import { decryptData } from "~/utils/crypto";
import { toast } from "react-toastify";
export const http = ky.extend({
  timeout: 30000,
  retry: 1,
  hooks: {
    beforeRequest: [
      (request) => {
        if (!request.url.includes("/prod/events?environment")) {
          try {
            const encryptedToken = localStorage.getItem("id_token");
            if (!encryptedToken) {
              console.error("No token found in localStorage");
              // Redirect to login page if no token is found
              window.location.href = "/";
              return;
            }

            const token = decryptData(encryptedToken);
            request.headers.set("Authorization", "Bearer " + token);
            // request.headers.set("x-api-key", process.env.VITE_BASE_API_KEY!);
          } catch (error) {
            console.error("Error setting Authorization header:", error);
            // Redirect to login page if token decryption fails
            window.location.href = "/";
            return;
          }
        }
        // Update last activity timestamp with URL information
        window.dispatchEvent(
          new CustomEvent("api-call", {
            detail: { url: request.url },
          })
        );
      },
    ],
    afterResponse: [
      async (_request: Request, _options: any, response: Response) => {
        if (response.status === 401) {
          console.log("Unauthorized request (401), redirecting to login");
          // Clear token on unauthorized to prevent redirect loops
          localStorage.removeItem("id_token");
          window.location.href = "/";
        }
        if (response.status === 403) {
          console.log("Bad request (403), redirecting to global exception");
          window.location.href = "#/globalexception";
        }
      },
    ],
  },
});

export const getGenericFiles = async <T>(url: string): Promise<T> => {
  return http
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(async (res) => res.json());
};
export const errorMessageHandler = async (error: any) => {
  try {
    if (error.name === "HTTPError") {
      const { message } = await error.response.json();
      const { status } = error.response;
      if (status >= 400 && status <= 599) {
        if (message?.toLowerCase()?.includes("internal")) {
          toast.error("Something went wrong", { theme: "colored" });
        } else {
          toast.error(message, { theme: "colored" });
        }   
      }
    }
  } catch (e) {
    console.log(e);
  }
};
